import { FC, ReactNode } from "react"
import styles from "./index.module.scss"



interface IProps {
    children: ReactNode
    className?: string
}

const ContractorBox: FC<IProps> = ({ children, className=null }) => {
    return (
        <div className={styles.box + ` ${className}`}>
            {children}
        </div>
    )
}

export default ContractorBox